import script from "./ContactView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactView.vue?vue&type=script&setup=true&lang=js"

import "./ContactView.vue?vue&type=style&index=0&id=154f975d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-154f975d"]])

export default __exports__